/**
 * @generated SignedSource<<597167708ddf2422e6ac7129a67761f5>>
 * @relayHash 1c72061a9ff8d7b4a93f1d0481cc5da8
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/580.0.0-2026-10-07T07:45:34.775Z/NftProfileImportCollectionViewNftTileSubscription

import { ConcreteRequest } from 'relay-runtime';
export type NftProfileImportCollectionViewNftTileSubscription$variables = {
  id: string;
};
export type NftProfileImportCollectionViewNftTileSubscription$data = {
  readonly nftItemDraftUpdate: {
    readonly nftItemDraft: {
      readonly serviceId: string | null;
    } | null;
  } | null;
};
export type NftProfileImportCollectionViewNftTileSubscription = {
  response: NftProfileImportCollectionViewNftTileSubscription$data;
  variables: NftProfileImportCollectionViewNftTileSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "nftItemId",
        "variableName": "id"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NftProfileImportCollectionViewNftTileSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "NftItemDraftUpdateSubscriptionPayload",
        "kind": "LinkedField",
        "name": "nftItemDraftUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NftItemDraft",
            "kind": "LinkedField",
            "name": "nftItemDraft",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscriptions",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "NftProfileImportCollectionViewNftTileSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "NftItemDraftUpdateSubscriptionPayload",
        "kind": "LinkedField",
        "name": "nftItemDraftUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NftItemDraft",
            "kind": "LinkedField",
            "name": "nftItemDraft",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/580.0.0-2026-10-07T07:45:34.775Z/NftProfileImportCollectionViewNftTileSubscription",
    "metadata": {},
    "name": "NftProfileImportCollectionViewNftTileSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "9451c470cd2cb12ca6aefa9efd4ca1bc";

export default node;
